import React from "react";
import CheckoutNote from "./CheckoutNote";
import { hasCustomParts } from "../../customParts/helpers";

export default function NonRefundable({parts}) {

  if (hasCustomParts(parts)) {
    return (
      <CheckoutNote icon="info-circle" title="Custom Parts">
        Custom-made parts in your order are non-refundable.<br /><br/>
        A Customer Service Representative will contact you with manufacturing details if necessary.
      </CheckoutNote>
    );
  }

  return "";
}
